import useIntegrationLogs from './hooks/useIntegrationLogs';
import IntegrationLogsView from './view';

/**
 * IntegrationLogs modal.
 *
 * Usage:
 *   const logsModalRef = useRef();
 *   logsModalRef.current.open(integration);
 *
 * Props:
 *   modalRef — ref object exposed to the parent (imperative handle)
 */
export default function IntegrationLogs({ modalRef }) {
    const props = useIntegrationLogs();

    if (modalRef) {
        modalRef.current = {
            open: props.openModal,
        };
    }

    return <IntegrationLogsView {...props} />;
}
